/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect, useImperativeHandle } from 'react';
import { Row, Col, Image, Space, Modal } from "antd";
import { NavLink } from "react-router-dom";
import AddIcon from "../../../../../../assets/images/icon_actions/Add Icon.svg";
import { LineForm } from "./LineForm";
import { PrimaryDrawer } from "../../../../../Shared/components/Drawer/PrimaryDrawer";
import CustomInfiniteScroll from "../../../../../Shared/components/CustomInfiniteScroll";
import { orderLineHead } from '../../../../../../config/constant';
import { TableCell, TableRow, Button } from "@mui/material";
import { toast } from 'react-toastify';
import ViewIcon from "../../../../../../assets/images/icon_actions/View.svg";
import EditIcon from "../../../../../../assets/images/icon_actions/Edit.svg";
import DeleteIcon from "../../../../../../assets/images/icon_actions/Delete Icon.svg";
import { gstCalculation, capitalizeFirstLetter } from "../../../../../../helpers/utilities";
import { emptyValidation, customNumberValidation, customNumberValidationQuantity } from "../../../../../../helpers/validation";
import { getRequest } from '../../../../../../helpers/axiosClient';




export const LinesList = React.forwardRef((props, ref) => {
    const { classes, clsx, form, lines, getColumnWidth, unitMesurementdetails, customObject, productPrices, parameterDetails,
        myProductdetails, currencyFormat, dispatch, productActions, locationApi, locationDetails, hsnApi, partyGstdetails, businessDetails,
        lineSubmit, deleteLine, headerView, useEventListener, productApi, handleAddProducts, roleManagement, checkComponentPermission
    } = props;
    const priceRef = useRef(null);
    const addLineRef = useRef(null);
    const [lineForm, setLineForm] = useState({});
    const [lineError, setLineError] = useState({});
    const [visible, setVisible] = useState(false);
    const [title, setTitle] = useState('Add');
    const [unitPriceFocusList, setUnitPriceFocusList] = useState(false);
    const [unitPriceList, setUnitPriceList] = useState(false);
    const [lineId, setLineId] = useState('');
    const [view, setView] = useState(false);
    const [deleteVisible, setDeleteVisible] = useState(false);
    const [line, setLine] = useState('');
    const [units, setUnits] = useState([]);
    const [availableQuantity, setAvailableQuantity] = useState(0);
    const [, setNegativeQuantity] = useState(false);
    const [negativeQuantityVisible, setNegativeQuantityVisible] = useState(false);

    const handleOpen = () => {
        setTitle('Add');
        setVisible(!visible);
        setView(false);
        let a = locationDetails?.filter(el => el.default);
        let locationId = locationDetails[0]?.id;
        let location = locationDetails[0];
        if (a?.length > 0) {
            locationId = a[0]?.id;
            location = a[0];
        }
        setNegativeQuantity(false);
        setNegativeQuantityVisible(false);
        setLineForm({
            includeGst: form?.includeGst,
            lineNumber: parseInt(lines?.length + 1),
            address: form?.address1 || '',
            area: form?.areaName || '',
            state: form?.stateName || '',
            city: form?.cityName || '',
            locationId: locationId,
            location: location,
            country: form?.countryName || '',
            pincode: form?.pincodeValue || '',
            discountType: parameterDetails?.discountRate ? 'perUnit' : 'fixed',
            excisesType: 'perUnit', excisesSplType: 'perUnit'
        });
        dispatch({ type: productActions.CLEAR_PRICE_START });
        hsnApi(); productApi(); locationApi();
        setLineId('');
        setLineError({});
    }

    useImperativeHandle(ref, () => ({
        getVisible() {
            return visible
        },
        handleLineSubmit(e) {
            handleLineSubmit(e)
        }
    }));

    useEffect(() => {
        handleSetProductPrice(lineForm, lineForm?.unitId);
    }, [productPrices]);

    // const calculateTotal = () => {
    //     let data = {
    //         cgst: '', sgst: '', igst: '', cgstAmount: '', sgstAmount: '', igstAmount: ''
    //     };
    //     var amount = lineForm?.quantity * lineForm?.pricePerUnit;
    //     var dPAmount = 0;
    //     var gAmount = 0;
    //     var dTotal = 0;
    //     if (lineForm?.unitId === lineForm?.productUnitId) {
    //         if (lineForm?.useMrp && lineForm?.maxRetailPrice !== '' && parseFloat(lineForm?.maxRetailPrice) < parseFloat(lineForm?.pricePerUnit)) {
    //             toast.dismiss();
    //             toast.warning('Unit price is greater than MRP Price');
    //         }
    //     }

    //     if (lineForm?.discountPercent) {
    //         dPAmount = dTotal = parseFloat((amount * lineForm?.discountPercent) / 100);
    //     }

    //     if (lineForm?.discountAmount) {
    //         if (amount < 0) {
    //             dTotal = parseFloat(dPAmount) - parseFloat(lineForm?.discountAmount);
    //         } else {
    //             dTotal = parseFloat(dPAmount) + parseFloat(lineForm?.discountAmount);
    //         }
    //     }
    //     var lineAmount = amount - dTotal;
    //     data['amount'] = lineAmount;


    //     if (lineForm?.productGstId && lineForm?.includeGst) {
    //         if (form?.partyGstId === '') {
    //             data['ProductGstId'] = '';
    //             toast.dismiss();
    //             toast.warning('Please select party GST code');
    //             return false;
    //         }
    //         let party = partyGstdetails && partyGstdetails.filter((el) => { return el.id === form?.partyGstId });
    //         if (party.length !== 0) {
    //             let p = party[0].productGsts && party[0].productGsts.filter((el) => { return el.id === lineForm?.productGstId });
    //             if (p && p.length !== 0) {
    //                 let percentage = p[0].percentage;
    //                 let details = {
    //                     percentage: percentage,
    //                     stateId: form?.stateId,
    //                     lineAmount: lineAmount || 0, priceIncludesTax: form?.priceIncludesTax || false
    //                 };
    //                 let gstCalc = gstCalculation(businessDetails, details, form?.customer);
    //                 data['cgstPercentage'] = parseFloat(gstCalc.cgst || 0);
    //                 data['sgstPercentage'] = parseFloat(gstCalc.sgst || 0);
    //                 data['igstPercentage'] = parseFloat(gstCalc.igst || 0);
    //                 data['cgst'] = parseFloat(gstCalc.cgstAmount || 0);
    //                 data['sgst'] = parseFloat(gstCalc.sgstAmount || 0);
    //                 data['igst'] = parseFloat(gstCalc.igstAmount || 0);
    //                 gAmount = parseFloat(gstCalc.gAmount || 0);
    //             } else {
    //                 toast.dismiss();
    //                 toast.error('This Product GST Code is not relevant for the Chosen Party GST Code, Please Check');
    //                 data['productGstId'] = '';
    //             }
    //         }
    //     }
    //     setLineForm({
    //         ...lineForm, ...data,
    //         gstAmount: gAmount,
    //         discountPercAmount: dPAmount,
    //         discountCalcAmount: dTotal
    //     });
    // }

    const calculateTotal = () => {
        let data = {
            cgst: '', sgst: '', igst: '', cgstAmount: '', sgstAmount: '', igstAmount: ''
        };
        var amount = lineForm?.quantity * lineForm?.pricePerUnit;
        var dPAmount = 0;
        var gAmount = 0;
        var dTotal = 0;
        data['salesValue'] = amount;
        if (lineForm?.unitId === lineForm?.productUnitId) {
            if (lineForm?.useMrp && lineForm?.maxRetailPrice !== '' && parseFloat(lineForm?.maxRetailPrice) < parseFloat(lineForm?.pricePerUnit)) {
                toast.dismiss();
                toast.warning('Unit price is greater than MRP Price');
            }
        }

        if (lineForm?.discountPercent) {
            dPAmount = dTotal = parseFloat((amount * lineForm?.discountPercent) / 100);
        }

        let discountAmount = lineForm?.discountAmount;
        if (lineForm?.discountType === 'perUnit') {
            const qty = parseFloat(lineForm?.quantity || 0);
            const rate = parseFloat(lineForm?.discountRate || 0);
            discountAmount = Math.abs(qty) * Math.abs(rate);
            data['discountAmount'] = discountAmount;
        }

        if (discountAmount) {
            if (amount < 0) {
                dTotal = parseFloat(dPAmount) - parseFloat(discountAmount);
            } else {
                dTotal = parseFloat(dPAmount) + parseFloat(discountAmount);
            }
        }
        var lineAmount = amount - dTotal;
        data['amount'] = lineAmount;


        if (lineForm?.productGstId && lineForm?.includeGst) {
            if (form?.partyGstId === '') {
                data['ProductGstId'] = '';
                toast.dismiss();
                toast.warning('Please select party GST code');
                return false;
            }
            let party = partyGstdetails && partyGstdetails.filter((el) => { return el.id === form?.partyGstId });
            if (party.length !== 0) {
                let p = party[0].productGsts && party[0].productGsts.filter((el) => { return el.id === lineForm?.productGstId });
                if (p && p.length !== 0) {
                    let percentage = p[0].percentage;
                    let details = {
                        percentage: percentage,
                        stateId: form?.stateId,
                        lineAmount: lineAmount || 0,
                        priceIncludesTax: form?.priceIncludesTax || false
                    };
                    let gstCalc = gstCalculation(businessDetails, details, form?.customer);
                    data['cgstPercentage'] = parseFloat(gstCalc.cgst || 0);
                    data['sgstPercentage'] = parseFloat(gstCalc.sgst || 0);
                    data['igstPercentage'] = parseFloat(gstCalc.igst || 0);
                    data['cgst'] = parseFloat(gstCalc.cgstAmount || 0);
                    data['sgst'] = parseFloat(gstCalc.sgstAmount || 0);
                    data['igst'] = parseFloat(gstCalc.igstAmount || 0);
                    gAmount = parseFloat(gstCalc.gAmount || 0);
                } else {
                    toast.dismiss();
                    toast.error('This Product GST Code is not relevant for the Chosen Party GST Code, Please Check');
                    data['productGstId'] = '';
                }
            }
        }

        if (lineForm?.excisesApplicable) {
            let excisesAmount = 0;
            let splExcisesAmount = 0;
            if (lineForm?.excisesType === 'perUnit') {
                const qty = parseFloat(lineForm?.quantity || 0);
                const rate = parseFloat(lineForm?.excisesRate || 0);
                excisesAmount = Math.abs(qty) * Math.abs(rate);
                excisesAmount = qty < 0 ? -excisesAmount : excisesAmount;
                data['excisesAmount'] = excisesAmount;
            } else {
                excisesAmount = lineForm?.excisesAmount;
            }
            if (lineForm?.excisesSplType === 'perUnit') {
                const sqty = parseFloat(lineForm?.quantity || 0);
                const srate = parseFloat(lineForm?.excisesSplRate || 0);
                splExcisesAmount = Math.abs(sqty) * Math.abs(srate);
                splExcisesAmount = sqty < 0 ? -splExcisesAmount : splExcisesAmount;
                data['excisesSplAmount'] = splExcisesAmount;
            } else {
                splExcisesAmount = lineForm?.excisesSplAmount;
            }
            let excisesTotal = parseFloat(excisesAmount) + parseFloat(splExcisesAmount || 0) + parseFloat(lineForm?.excisesAddAmount || 0);
            data['excisesTotal'] = excisesTotal;
            data['totalCostPrice'] = excisesTotal + (lineAmount || 0);
        }
        setLineForm({
            ...lineForm, ...data,
            gstAmount: gAmount,
            discountPercAmount: dPAmount,
            discountCalcAmount: dTotal
        });
    }

    useEffect(() => {
        calculateTotal();
    }, [lineForm?.quantity, lineForm?.pricePerUnit, lineForm?.excisesType, lineForm?.excisesRate, lineForm?.excisesAmount, lineForm?.excisesSplType, lineForm?.excisesSplRate, lineForm?.excisesSplAmount, lineForm?.excisesAddAmount, lineForm?.discountAmount, lineForm?.discountPercent, lineForm?.productGstId, visible]);

    const handleSetProductPrice = (lineForm, lineUnitId = '') => {
        let data = {};

        if (productPrices && productPrices !== '') {
            let d = customObject(myProductdetails, lineForm?.productId);
            console.log(d);
            if (parameterDetails?.aggrementSalesPrice && productPrices?.priceagreement && Object.keys(productPrices?.priceagreement).length > 0 &&
                productPrices?.priceagreement[customObject(unitMesurementdetails, lineUnitId)?.name]) {
                let result = productPrices?.priceagreement[customObject(unitMesurementdetails, lineUnitId)?.name][0];
                console.log(productPrices?.priceagreement);
                data['pricePerUnit'] = result?.price || d?.costPrice || '';
                data['maxRetailPrice'] = result?.mrp || d?.mrp || '';
                data['excisesSplRate'] = result?.specialExcisesDuty || '';

                setUnitPriceList(true);
                data['useMrp'] = result?.isMrp;
            } else {
                if (parameterDetails?.lastSalesPrice && productPrices?.lastprice && Object.keys(productPrices?.lastprice).length > 0 &&
                    productPrices?.lastprice[customObject(unitMesurementdetails, lineUnitId)?.name]) {
                    let result = productPrices?.lastprice[customObject(unitMesurementdetails, lineUnitId)?.name];
                    data['pricePerUnit'] = result?.price || d?.latestPurchasePrice || '';
                    if (result?.mrp || d?.mrp) {
                        data['maxRetailPrice'] = result?.mrp || d?.mrp || '';
                        data['useMrp'] = true;

                    }
                    setUnitPriceList(false);
                } else {
                    if (parameterDetails?.productUnitPrice) {
                        let d = customObject(myProductdetails, lineForm?.productId);
                        if (d) {
                            data['useMrp'] = d?.useMrp;
                            data['pricePerUnit'] = d?.costPrice || '';
                            data['maxRetailPrice'] = d?.mrp || '';
                        }
                    }
                }
            }
            if (productPrices?.discountagreement && Object.keys(productPrices?.discountagreement).length > 0 &&
                productPrices?.discountagreement[customObject(unitMesurementdetails, lineUnitId)?.name]) {
                let result = productPrices?.discountagreement[customObject(unitMesurementdetails, lineUnitId)?.name][0];
                if (parameterDetails?.discountRate) {
                    data['discountRate'] = result?.price || '';
                } else {
                    data['discountAmount'] = result?.price || '';
                }
                data['discountPercent'] = result?.percentage || '';
            } else if (productPrices?.lastdiscount &&
                Object.keys(productPrices?.lastdiscount).length > 0 &&
                productPrices?.lastdiscount[customObject(unitMesurementdetails, lineUnitId)?.name]) {
                data['discountPercent'] = productPrices?.lastdiscount[customObject(unitMesurementdetails, lineUnitId)?.name]?.percent || '';
                if (parameterDetails?.discountRate) {
                    data['discountRate'] = productPrices?.lastdiscount[customObject(unitMesurementdetails, lineUnitId)?.name]?.rate || '';
                } else {
                    data['discountAmount'] = productPrices?.lastdiscount[customObject(unitMesurementdetails, lineUnitId)?.name]?.amount || '';
                }
            } else {
                data['discountAmount'] = '';
                data['discountPercent'] = '';
            }
        } else {
            data['discountAmount'] = '';
            data['discountPercent'] = '';

            if (parameterDetails?.productUnitPrice) {
                let d = customObject(myProductdetails, lineForm?.productId);
                data['useMrp'] = d?.useMrp || false;
                data['pricePerUnit'] = d?.costPrice || '';
                data['maxRetailPrice'] = d?.mrp || '';
            }
        }

        setLineForm({
            ...lineForm,
            ...data,
        });
    }

    const onEdit = (data, i, view = false) => {
        setLineId(i);
        setTitle(view ? 'View' : 'Edit');
        setView(view);
        setVisible(!visible);
        data.pricePerUnit = data?.pricePerUnit || 0;
        setLineForm(data);
        hsnApi('', data?.hsnId || '');
        productApi('', data?.productId || '');

    }

    const shouldBlur = (e) => {
        setUnitPriceList(false);
        setUnitPriceFocusList(false);
    }

    const onDelete = (data, i) => {
        setDeleteVisible(true);
        setLineId(i);
        setLine(data);
    }

    const handleProductChange = (d) => {
        if (d?.id) {
            let data = {
                productId: d?.id,
                product: d
            }

            data['description'] = d.productName;
            data['unitId'] = d?.defaultSalesUnitId || d?.salesUnitId || '';
            data['unit'] = d?.defaultSalesUnit || d.salesUnit || '';
            data['productUnitId'] = d?.defaultSalesUnitId || d.salesUnitId || '';
            data['productUnit'] = d?.defaultSalesUnit || d.salesUnit || '';
            data['universalProductId'] = d.universalProductId;

            dispatch({
                type: productActions.PRODUCT_PRICE_START,
                url: `/saledprice/${form?.customerId}/${d.id}/${lineForm?.quantity || 1}`
            });
            if (form?.includeGst) {
                data['productGstId'] = d?.productGstId || '';
                data['productGst'] = d?.productGst || '';
                data['hsn'] = d?.hsn || '';
                data['hsnId'] = d?.hsnId || '';
                hsnApi('', d.hsnId);
            }
            data['excisesApplicable'] = d?.exciseApplicable || false;
            if (!d?.productGstId && d?.exciseApplicable) {
                data['includeGst'] = false;
            }
            if (d?.exciseApplicable) {
                data['excisesType'] = 'perUnit';
                data['excisesSplType'] = 'perUnit';
            }

            setLineForm({ ...lineForm, ...data });

            if (parameterDetails?.inventoryTransaction) {
                handleUnits(d);
                getAvailableQty(d?.id, d?.defaultSalesUnitId || d?.salesUnitId, lineForm?.locationId);
            }

        }
    }

    const handleUnits = (data) => {
        let filter = {
            where: {
                and: [{ productId: data?.id }, { or: [{ unitId: (data?.defaultSalesUnitId || data?.salesUnitId) }, { toUnitId: (data?.defaultSalesUnitId || data?.salesUnitId) },] }]
            }
        }; let uFilter = {
            where: {
                or: [{ unitId: (data?.defaultSalesUnitId || data?.salesUnitId) }, { toUnitId: (data?.defaultSalesUnitId || data?.salesUnitId) }]
            }
        };
        let a = [data?.salesUnitId, data?.skuUnitId, data?.defaultSalesUnitId];

        getRequest(`${process.env.REACT_APP_API_URL}/product-unit-conversions/?filter=${encodeURIComponent(JSON.stringify(filter))}`)
            .then(response => {
                let data = response.data;
                if (data && data.length > 0) {
                    data.forEach(el => {
                        a.push(el.unitId)
                        a.push(el.toUnitId);
                    });
                }
                return getRequest(`${process.env.REACT_APP_API_URL}/unit-conversions/?filter=${encodeURIComponent(JSON.stringify(uFilter))}`);
            }).then(uResponse => {
                let uData = uResponse.data;
                if (uData && uData.length > 0) {
                    uData.forEach(el => {
                        a.push(el.unitId)
                        a.push(el.toUnitId)
                    });
                }
                const filtered = unitMesurementdetails.filter(el => a.includes(el.id));
                setUnits(filtered);
            })
            .catch(error => {
                console.error("Error fetching data", error);
            });
    }

    const getAvailableQty = async (id, unitId, locationId) => {
        try {
            const response = await getRequest(`${process.env.REACT_APP_API_URL}/stock-on-hands/byProduct/${id}/${unitId}/${locationId}`);
            const data = response.data;
            // let val = [];

            if (data?.length && data[0]?.units?.length) {
                let qty = data[0]?.units.find(obj => obj.hasOwnProperty(unitId))?.[unitId];
                setAvailableQuantity(parseFloat(parseFloat(qty).toFixed(2)));
            } else {
                setAvailableQuantity(0);
            }

            if (data?.length && data[0]?.cPrice?.length) {
                let qty = data[0]?.cPrice.find(obj => obj.hasOwnProperty(unitId))?.[unitId];
                setLineForm(prev => ({
                    ...prev,
                    costPrice: parseFloat(parseFloat(qty).toFixed(2))
                }));
            } else {
                setLineForm(prev => ({
                    ...prev,
                    costPrice: 0
                }));
            }
        } catch (error) {
            console.log(error);
        }
    }

    const changeHandler = (e, name = '') => {
        if (name !== '') {
            if (name === 'unitId') {
                // setLineForm({
                //     ...lineForm,
                //     [name]: e.id,
                //     'unit': e
                // });
                setLineForm(prev => {
                    const updated = {
                        ...prev,
                        unitId: e.id,
                        unit: e
                    };
                    handleSetProductPrice(updated, e.id);
                    return updated;
                });
            } else if (name === 'productGstId') {
                setLineForm({
                    ...lineForm,
                    [name]: e.id,
                    'productGst': e
                });
            } else if (name === 'hsnId') {
                setLineForm({
                    ...lineForm,
                    [name]: e.id,
                    'hsn': e
                });
            } else if (name === 'locationId') {
                setLineForm({
                    ...lineForm,
                    [name]: e.id,
                    'location': e
                });
            } else {
                setLineForm({
                    ...lineForm,
                    [name]: e
                });
            }
        } else {
            setLineForm({
                ...lineForm,
                [e.target.name]: e.target.value
            });
        }
    }

    const handleProductPrice = (key) => {
        let a = unitMesurementdetails && unitMesurementdetails.filter((el) => { return el.name === key });
        let data = {};
        if (a && a?.length !== 0) {
            data = {
                ...data,
                unitId: a[0]?.id,
                productLineUnitId: a[0]?.id
            };
            if (lineForm?.productId !== '') {
                let productData = customObject(myProductdetails, lineForm?.productId);
                data = {
                    ...data,
                    useMrp: productData?.salesUnitId !== a[0]?.id ? false : productData?.useMrp
                };
            }
        }
        if (productPrices?.lastprice && Object.keys(productPrices?.lastprice).length > 0 &&
            productPrices?.lastprice[key]) {
            let result = productPrices?.lastprice[key];
            data = {
                ...data,
                pricePerUnit: result?.price,
                maxRetailPrice: result?.mrp || ''
            };
        }
        setLineForm({
            ...lineForm, ...data
        });
        setUnitPriceList(false);
        setUnitPriceFocusList(false);
    }

    const handleQuantityChange = (value) => {
        if (lineForm?.productId && value) {
            if (priceRef.current !== null) {
                clearTimeout(priceRef.current);
            }
            priceRef.current = setTimeout(() => {
                priceRef.current = null;
                dispatch({
                    type: productActions.PRODUCT_PRICE_START,
                    url: `/saledprice/${form?.customerId}/${lineForm?.productId}/${value}`
                });
            }, 500);
        }
    }

    const handleLineIncludeGst = (value) => {
        setLineError({
            ...lineError, productGstId: false
        });
        let data = {
            includeGst: value,
        };
        if (value) {
            let party = partyGstdetails && partyGstdetails.filter((el) => { return el.id === form?.partyGstId });
            if (party.length !== 0) {
                let p = party[0].productGsts && party[0].productGsts.filter((el) => { return el.id === lineForm?.productGstId });
                if (p.length !== 0) {
                    let percentage = p[0].percentage;
                    let details = {
                        percentage: percentage,
                        stateId: form?.stateId,
                        lineAmount: lineForm?.amount || ''
                    };

                    let gstCalc = gstCalculation({
                        ...businessDetails,
                        priceIncludesTax: form?.priceIncludesTax || false
                    }, details, form?.customer);
                    data['cgstPercentage'] = parseFloat(gstCalc?.cgst || 0);
                    data['sgstPercentage'] = parseFloat(gstCalc?.sgst || 0);
                    data['igstPercentage'] = parseFloat(gstCalc?.igst || 0);
                    data['cgst'] = parseFloat(gstCalc?.cgstAmount || 0);
                    data['sgst'] = parseFloat(gstCalc?.sgstAmount || 0);
                    data['igst'] = parseFloat(gstCalc?.igstAmount || 0);
                    data['gstAmount'] = parseFloat(gstCalc.gAmount || 0);
                }
            }
            setLineForm({
                ...lineForm, ...data
            })
        } else {
            setLineForm({
                ...lineForm,
                includeGst: value,
                gstAmount: 0,
                cgst: 0,
                sgst: 0,
                igst: 0,
                cgstAmount: 0,
                sgstAmount: 0, igstAmount: 0
            });
        }
    }

    const handleAddMore = (e) => {
        handleLineSubmit(e, false, true);
    }

    const handleLineSubmit = (e, isNegative = false, more = false) => {
        e.preventDefault();
        let emptyDescription = emptyValidation('Description', lineForm?.description);
        let emptyUnit = emptyValidation('Unit', lineForm?.unitId, 'dropDown');
        let emptyPrice = customNumberValidation('Price', lineForm?.pricePerUnit);
        let emptyQuantity = customNumberValidationQuantity('Quantity', lineForm?.quantity);
        let emptyAmount = emptyValidation('Line Amount', lineForm?.amount);
        let checkValidation = true;
        let emptyProductGst = emptyValidation('Product GST Code', lineForm?.productGstId, 'dropDown');
        let emptyHsn = emptyValidation('HSN', lineForm?.hsnId, 'dropDown');
        if ((lineForm?.includeGst && !emptyProductGst.isValid) || (lineForm?.includeGst && !emptyHsn.isValid)) {
            checkValidation = false;
        }

        let discountAgreeMents = true;
        let total = lineForm?.quantity * lineForm?.pricePerUnit;
        if (Math.abs(total) < Math.abs(lineForm?.discountCalcAmount)) {
            discountAgreeMents = false;
        }
        let emptyState = emptyValidation('State', lineForm?.state);
        let emptyPincode = emptyValidation('Pincode', lineForm?.pincode);
        let emptyCountry = emptyValidation('Country', lineForm?.country);
        let emptyCity = emptyValidation('City', lineForm?.city);

        // let negativeQuantityCheck = { isValid: true, errors: '' };
        console.log(isNegative);
        if (!isNegative && lineForm?.productId && !parameterDetails?.negativeStock && parameterDetails?.inventoryTransaction) {
            let qty = availableQuantity - Math.abs(lineForm?.quantity);
            if (qty < 0) {
                //  setNegativeQuantity(true);
                setNegativeQuantityVisible(true);
                return false;
                //   negativeQuantityCheck = { isValid: false, errors: 'There is no stocks available' }
            }
        }

        setLineError({});
        if (emptyDescription.isValid &&
            emptyUnit.isValid && discountAgreeMents &&
            emptyPrice.isValid && emptyQuantity.isValid && emptyAmount.isValid && checkValidation &&
            emptyState.isValid && emptyPincode.isValid && emptyCountry.isValid && emptyCity.isValid
        ) {
            lineForm.quantity = parseFloat(lineForm.quantity);
            if (lineForm?.sgstAmount) {
                lineForm.sgstAmount = parseInt(lineForm.sgstAmount);
            }
            if (lineForm?.cgstAmount) {
                lineForm.cgstAmount = parseFloat(lineForm.cgstAmount);
            }
            if (lineForm?.igstAmount) {
                lineForm.igstAmount = parseFloat(lineForm.igstAmount);
            }
            if (lineForm?.gstAmount) {
                lineForm.gstAmount = parseFloat(lineForm.gstAmount);
            }
            lineSubmit(lineForm, lineId);
            handleOpen();
            if (more) {
                setTimeout(function () {
                    addLineRef.current.click();
                }, 500)
            }
        } else {
            setLineError({
                description: emptyDescription?.errors || false,
                unitId: emptyUnit?.errors || false,
                discountAgreeMents: !discountAgreeMents ? 'Discount amount is greater than Line amount, please correct it.' : false,
                pricePerUnit: emptyPrice?.errors || false,
                quantity: emptyQuantity?.errors || false,
                productGstId: lineForm?.includeGst && emptyProductGst?.errors ? emptyProductGst?.errors : false,
                hsnId: lineForm?.includeGst && emptyHsn?.errors ? emptyHsn?.errors : false,
                state: emptyState?.errors || false,
                pincode: emptyPincode?.errors || false,
                country: emptyCountry?.errors || false,
                city: emptyCity?.errors || false
            })
        }
    }

    const handleKeyDown = (e) => {
        if (!headerView && e.altKey && e.keyCode === 76) {
            e.preventDefault();
            if (form?.customerId) {
                handleOpen();
            } else {
                toast.dismiss();
                toast.error('Please select customer then add lines.');
            }
        }
    };

    useEventListener("keydown", handleKeyDown);

    return (
        <>
            <Row>
                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className={classes.textAlignRight}>
                    <Space direction="horizontal" align="center" size={[10, 10]}>
                        {
                            roleManagement !== '' && checkComponentPermission('Sales Order', 'Page', 'Add Products') &&
                            <>
                                {
                                    form?.customerId && !headerView &&
                                    <NavLink to={'#'} onClick={() => handleAddProducts()} className={clsx(classes.customLink, classes.disInline)}>
                                        <Image
                                            src={AddIcon}
                                            preview={false}
                                            className={clsx(classes.antImage)}
                                        /><span className={clsx(classes.addLink, classes.color, classes.bold)}>Add Products</span>
                                    </NavLink>
                                }
                            </>
                        }
                        {
                            form?.customerId && !headerView &&
                            <NavLink to={'#'} ref={addLineRef} onClick={() => handleOpen()} className={clsx(classes.customLink, classes.disInline)}>
                                <Image
                                    src={AddIcon}
                                    preview={false}
                                    className={clsx(classes.antImage)}
                                /><span className={clsx(classes.addLink, classes.color, classes.bold)}>Add Lines</span>
                            </NavLink>
                        }
                    </Space>
                </Col>
            </Row>
            <div className={clsx(classes.tableRoot)}>
                <CustomInfiniteScroll
                    loadMore={true}
                    loadMoreContent={false}
                    heads={orderLineHead}
                    width={true}
                    component={
                        <>
                            {
                                lines?.length > 0 ? lines.map((data, i) => (
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} key={i}>
                                        <TableCell style={{ width: getColumnWidth(orderLineHead, 0) }}><span style={{ width: getColumnWidth(orderLineHead, 0) }}>{i + 1}</span></TableCell>
                                        <TableCell style={{ width: getColumnWidth(orderLineHead, 1) }}><NavLink style={{ width: getColumnWidth(orderLineHead, 1) }} to={"#"} className={clsx(classes.bold, classes.color)} onClick={() => onEdit(data, i, true)}><span className={classes.descEllipsis}>{data.description}</span></NavLink></TableCell>
                                        <TableCell style={{ width: getColumnWidth(orderLineHead, 2) }}><span style={{ width: getColumnWidth(orderLineHead, 2) }}>{data.quantity ? data.quantity : '---'}</span></TableCell>
                                        <TableCell style={{ width: getColumnWidth(orderLineHead, 3) }}><span style={{ width: getColumnWidth(orderLineHead, 4) }}>{data.unit?.name || '---'}</span></TableCell>
                                        <TableCell style={{ width: getColumnWidth(orderLineHead, 5) }} className={classes.textAlignRight}><span style={{ width: getColumnWidth(orderLineHead, 5) }}>{`₹ ${currencyFormat(data?.pricePerUnit || 0)}`}</span></TableCell>
                                        <TableCell style={{ width: getColumnWidth(orderLineHead, 6) }} className={classes.textAlignRight}><span style={{ width: getColumnWidth(orderLineHead, 6) }}>
                                            {`₹ ${(data.discountAmount || data.discountPercent) ?
                                                (data.quantity < 0 ?
                                                    currencyFormat((parseFloat(data?.discountAmount || 0) - parseFloat(((data.quantity * data.pricePerUnit) * data.discountPercent) / 100))) :
                                                    currencyFormat((parseFloat(data?.discountAmount || 0) + parseFloat(((data.quantity * data.pricePerUnit) * data.discountPercent) / 100))))
                                                : currencyFormat(0)}`}
                                        </span>
                                        </TableCell>
                                        <TableCell style={{ width: getColumnWidth(orderLineHead, 7) }} className={classes.textAlignRight}><span style={{ width: getColumnWidth(orderLineHead, 7) }}>{`₹ ${currencyFormat(data?.amount || 0)}`}</span></TableCell>
                                        <TableCell style={{ width: getColumnWidth(orderLineHead, 8) }} className={classes.textAlignRight}><span style={{ width: getColumnWidth(orderLineHead, 8) }}>{`₹ ${currencyFormat(data?.excisesTotal || 0)}`}</span></TableCell>

                                        <TableCell style={{ width: getColumnWidth(orderLineHead, 9) }}><span style={{ width: getColumnWidth(orderLineHead, 9) }}>
                                            {data.productGst?.code || '---'}
                                        </span></TableCell>
                                        <TableCell style={{ width: getColumnWidth(orderLineHead, 10) }} className={classes.textAlignRight}><span style={{ width: getColumnWidth(orderLineHead, 10) }}>₹ {data.gstAmount ? currencyFormat(data.gstAmount) : '0.00'}</span></TableCell>
                                        <TableCell style={{ width: getColumnWidth(orderLineHead, 11) }}><span style={{ width: getColumnWidth(orderLineHead, 11) }}>
                                            <span style={{ display: "inline-block" }} className={clsx(classes.statusButton, { [classes.openButton]: data?.lineStatus === 'CREATED' || !data?.lineStatus }, { [classes.fullButton]: (data?.lineStatus === 'DELIVERED' || data?.lineStatus === 'INVOICED') })}>
                                                {
                                                    (data?.lineStatus === 'CREATED' || !data?.lineStatus) ? 'Open' : capitalizeFirstLetter(data.lineStatus)
                                                }
                                            </span>
                                        </span></TableCell>
                                        <TableCell className={classes.textAlignRight}>
                                            <Space direction="horizontal" align="center" size={[0, 0]} className={clsx(classes.iconPadding)}>
                                                <NavLink to={"#"} onClick={() => onEdit(data, i, true)}>
                                                    <Image
                                                        src={ViewIcon}
                                                        preview={false}
                                                    />
                                                </NavLink>
                                                {
                                                    !headerView && <NavLink to={"#"} onClick={() => onEdit(data, i)}>
                                                        <Image
                                                            src={EditIcon}
                                                            preview={false}
                                                        />
                                                    </NavLink>
                                                }
                                                {
                                                    !headerView &&
                                                    <NavLink to={"#"} onClick={() => onDelete(data, i)}>
                                                        <Image
                                                            src={DeleteIcon}
                                                            preview={false}
                                                        />
                                                    </NavLink>
                                                }
                                            </Space>
                                        </TableCell>
                                    </TableRow>
                                )) : <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell style={{ textAlign: "center" }} colSpan={10}>
                                        <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'Start by Adding Lines to your Order'}</p>

                                    </TableCell>
                                </TableRow>
                            }
                        </>
                    }
                />
            </div>
            <PrimaryDrawer
                anchor={'right'}
                open={visible}
                variant={'temporary'}
                handleClose={() => handleOpen()}
                width={'690px'}
                title={title + ' Order Lines'}
                className={clsx(classes.closeBackGround, classes.width100PCustomerandSales)}
                component={
                    <LineForm {...props}
                        handleLineSubmit={(e) => handleLineSubmit(e)}
                        lineForm={lineForm}
                        title={title}
                        view={view}
                        headerView={headerView}
                        handleAddMore={(e) => handleAddMore(e)}
                        lineError={lineError}
                        unitPriceFocusList={unitPriceFocusList}
                        unitPriceList={unitPriceList}
                        handleEdit={(v) => setView(v)}
                        shouldBlur={(e) => shouldBlur(e)}
                        currencyFormat={(amount) => currencyFormat(amount)}
                        handleProductPrice={(key) => handleProductPrice(key)}
                        priceFocusList={(v) => setUnitPriceFocusList(v)}
                        handleQuantityChange={(v) => handleQuantityChange(v)}
                        changeHandler={(e, name) => changeHandler(e, name)}
                        handleProductChange={(data) => handleProductChange(data)}
                        handleLineIncludeGst={(v) => handleLineIncludeGst(v)}
                        units={units}
                        availableQuantity={availableQuantity}
                    />
                }
            />
            <Modal title={'Delete Confirmation'}
                open={deleteVisible}
                onOk={() => setDeleteVisible(false)}
                onCancel={() => setDeleteVisible(false)}
                className={clsx(classes.commonPopup, classes.deletePopup, classes.removeUnderline)}
                footer={[
                    <Button
                        key="yes"
                        type='submit'
                        color='primary'
                        variant="contained"
                        className={clsx(classes.modalBtn)}
                        onClick={() => { setDeleteVisible(false); deleteLine(lineId, line?.id || '') }}
                    >Yes</Button>,
                    <Button
                        key="no"
                        type='submit'
                        color='primary'
                        variant="contained"
                        className={clsx(classes.modalBtn, classes.AddMoreBtn)}
                        onClick={() => setDeleteVisible(false)}>
                        No
                    </Button>
                ]}>
                <p>Are you sure you want to <span className={classes.deleteRed}> Delete </span> {line?.description || ''}</p>
            </Modal>
            <Modal title={'Allow Negative Quantity'}
                open={negativeQuantityVisible}
                onOk={() => setNegativeQuantityVisible(false)}
                onCancel={() => setNegativeQuantityVisible(false)}
                className={clsx(classes.commonPopup, classes.deletePopup, classes.removeUnderline)}
                footer={[
                    <Button
                        key="yes"
                        type='submit'
                        color='primary'
                        variant="contained"
                        className={clsx(classes.modalBtn)}
                        onClick={(e) => handleLineSubmit(e, true)}
                    >Yes</Button>,
                    <Button
                        key="no"
                        type='submit'
                        color='primary'
                        variant="contained"
                        className={clsx(classes.modalBtn, classes.AddMoreBtn)}
                        onClick={() => setNegativeQuantityVisible(false)}>
                        No
                    </Button>,
                ]}>
                <p>No stock available. Aree you sure want to<span className={classes.deleteRed}> continue? </span> {line?.description || ''}</p>
            </Modal>
        </>
    )
})